module.exports = __webpack_public_path__ + "60a501d4c2b1d1e8cdb49ee8e2b716ac.svg";